import React, { useEffect, useState } from 'react'
import { GetCompanyInfo, GetFooter, GetHomeSliderItems, GetNavBarItems, GetRegistrationProfits, GetSuppliersLogo } from '../Services/CompanyInfoService';
import { useConfig } from '../Providers/ConfigProvider';

const useGetCompanyInfo = () => {
  const { api } = useConfig()

  const [footerData, setFooterData] = useState([])
  const [companyInfoData, setCompanyInfoData] = useState([])
  const [navBarItems, setNavBarItems] = useState([])
  const [supplierLogoItems, setSupplierLogoItems] = useState([])
  const [homeSliderItems, setHomeSliderItems] = useState([])
  const [registrationProfits, setRegistrationProfits] = useState([])

  const [loadingData, setLoadingData] = useState(true)

  useEffect(() => {
    fetchData()
  }, [api])

  const fetchData = async () => {
    setLoadingData(true)
    try {
      const [companyRes, footerRes, navBarRes, supplierRes, homeSliderRes, registrationProfitsRes] = await Promise.all([
        GetCompanyInfo(api),
        GetFooter(api),
        GetNavBarItems(api),
        GetSuppliersLogo(api),
        GetHomeSliderItems(api),
        GetRegistrationProfits(api)
      ])
      setCompanyInfoData(companyRes.data)
      setFooterData(footerRes.data)
      setNavBarItems(navBarRes.data)
      setSupplierLogoItems(supplierRes.data)
      setHomeSliderItems(homeSliderRes.data)
      setRegistrationProfits(registrationProfitsRes.data)
      setLoadingData(false)
    } catch (e) {
      console.log(e)
      setNavBarItems([])
    }
  }

  return { footerData, companyInfoData, navBarItems, loadingData, registrationProfits }
}

export default useGetCompanyInfo